// extracted by mini-css-extract-plugin
export default {"item":"AboutPillarItem_item__Xp2A4","icon":"AboutPillarItem_icon__M3-k6","title":"AboutPillarItem_title__-Q-M5","text":"AboutPillarItem_text__q8t4D"};